// Nelielas SVG ikonas (bez ārējām bibliotēkām).

export const IconEdit = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
    <path d="M11.2 2.3l2.5 2.5L6 12.5l-3.2.8.8-3.2z" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
  </svg>
);

export const IconLink = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
    <path d="M2.5 12.5C4.5 5 9.5 4 13 6.8" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M9.6 4.6l3.6 2.3-2.5 3.3" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconChev = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
    <path d="M3 4.5l3 3 3-3" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconBolt = ({ w = 12, h = 16 }: { w?: number; h?: number }) => (
  <svg width={w} height={h} viewBox="0 0 14 18" aria-hidden="true">
    <path d="M8.5 0L1 10.2h5.2L5 18l8-11.2H7.8z" fill="currentColor" />
  </svg>
);

export const BoltSm = () => (
  <svg viewBox="0 0 14 18" aria-hidden="true">
    <path d="M8.5 0L1 10.2h5.2L5 18l8-11.2H7.8z" fill="currentColor" />
  </svg>
);

export const IconSwap = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
    <path d="M3 5h9.5L10 2.5M13 11H3.5L6 13.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/** Neitrāla atslēgas ikona pieteikšanās pogai (bez trešo pušu zīmoliem). */
export const IconKey = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true">
    <circle cx="6.5" cy="10" r="3.6" fill="none" stroke="currentColor" strokeWidth="1.8" />
    <path d="M10 10h8M15 10v3M17.5 10v2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);
